import { useStore } from "@nanostores/react"

import { UserInfo } from "shared/types/UserInfo"

import { atom } from "nanostores"

const $userInfo = atom<UserInfo | null | undefined>(undefined)

export function setUserInfo(userInfo: UserInfo | null) {
  return $userInfo.set(userInfo)
}

export function useUserInfo() {
  return useStore($userInfo)
}
